module.exports = __webpack_public_path__ + "img/232.5b95bc79.png";